module.exports = __webpack_public_path__ + "img/search_blue.9367c0e6.svg";